import React from "react";
import style from "./style.scss";

import { FormattedMessage } from "react-intl";
import { Word } from "../../lang/Word";

export const Option = ({ value, children }) => {
    let element = (
        <option value={value} className={style.option}>
            {children}
        </option>
    );

    const child = children[0];
    if (child && (child.type === FormattedMessage || child.type === Word)) {
        element = React.cloneElement(child, {
            children: (message) => {
                return (
                    <option value={value} className={style.option}>
                        {message}
                    </option>
                );
            }
        });
    }

    return element;
};
